/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResponseDto } from '../../models/auth-response-dto';
import { SwitchOrganizationRequestDto } from '../../models/switch-organization-request-dto';

export interface AuthSwitchOrganizationPost$Json$Params {
      body?: SwitchOrganizationRequestDto
}

export function authSwitchOrganizationPost$Json(http: HttpClient, rootUrl: string, params?: AuthSwitchOrganizationPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authSwitchOrganizationPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseDto>;
    })
  );
}

authSwitchOrganizationPost$Json.PATH = '/auth/switch-organization';
